<template>
  <page-view title="签名生成">
    <template slot="action">
      <a-button type="primary" @click="handleOk">新增</a-button>
    </template>
    <a-card>
      <s-table
          ref="table"
          :columns="columns"
          :rowKey="record => record.id"
          :data="loadData"
      >
        <template slot="action" slot-scope="text">
          <a @click="onDelete(text.id)">删除</a>
        </template>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import STable from '@/components/Table'
import PageView from '@/layouts/PageView'
import qs from 'qs'

export default {
  name: 'SignatureIndex',
  components: { PageView, STable },
  data () {
    return {
      columns: [
        {
          title: '创建时间',
          dataIndex: 'createdAt',
          align: 'center'
        },
        {
          title: 'AccessKey',
          dataIndex: 'accessKey',
          align: 'center'
        },
        {
          title: 'SecretKey',
          dataIndex: 'secretKey',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'extras.state',
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: parameter => {
        return this.$http.get('/api/1/key/query.json', {
          params: Object.assign(parameter, this.form),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          return res
        })
      }
    }
  },
  methods: {
    onSearch () {
      this.$refs.table.refresh(true)
    },
    onDelete (id) {
      this.$http.post('/api/1/key/delete.json?id=' + id).then(resp => {
        if (resp.code !== 200) {
          return false
        }
        this.$message.success('删除成功')
        this.onSearch()
      })
    },
    handleOk () {
      this.$http.post('/api/1/key/create.json').then(resp => {
        if (resp.code !== 200) {
          return false
        }
        this.$message.success('创建成功')
        this.onSearch()
      })
    }
  }
}
</script>

<style scoped>

</style>
